import { Box, Container, Stack, styled } from "@mui/material";
import UserNav from "./UserNav";
import MobileNav from "./MobileNav";
import { Trans, useTranslation } from "react-i18next";
import DesktopNav from "./DesktopNav";
import Toast from "../UIData/_components/Toast";
import CookieConsent from "./CookieConsent";
import tKey from "../Common/Utils/tKey";
import HeaderLink, { HeaderNavigationProvider } from "./HeaderNavigation";
import LiveChatAiMessenger from "./LiveChat/LiveChatAiMessenger";

const FullLogo = styled('img')(({ theme }) => ({
  display: 'block',

  [theme.breakpoints.down('md')]: {
    display: 'none'
  }
}))

const SmallLogo = styled('img')(({ theme }) => ({
  display: 'none',

  [theme.breakpoints.down('md')]: {
    display: 'block'
  }
}))

const Promobar = styled(Stack)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  padding: '0.5rem 1rem',
  position: 'relative',
  textAlign: 'center',
  textTransform: 'uppercase',
  zIndex: 10,
}));

type Props = {
  clientRouterLinks?: boolean
}

export default function Header(props: Props) {
  const [tR] = useTranslation('routes')
  const [t] = useTranslation('header')

  return <HeaderNavigationProvider value={{ clientRouterLinks: props.clientRouterLinks ?? false }}>
    <LiveChatAiMessenger />

    <Box
      component="div"
      sx={{
        backgroundColor: 'secondary.main',
        position: 'fixed',
        top: 0,
        width: '100%',
        zIndex: theme => theme.zIndex.appBar,
      }}
    >
      <Container
        maxWidth="xl"
        disableGutters
        sx={{
          pl: {
            xs: 0,
            md: 3,
          },
          pr: {
            xs: 0,
            md: 1,
          },
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="stretch"
          sx={{
            height: {
              xs: '52px',
              md: '64px',
            }
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1} useFlexGap>
            <MobileNav />
            <HeaderLink to={tR('/')} reloadDocument>
              <FullLogo
                src={require('@resources/img/logo-new-nav-white.svg?url')}
                width="89"
                height="42"
                alt="Art of Where"
              />
              <SmallLogo
                src={require('@resources/img/logo-small.svg?url')}
                width="85"
                height="24"
                alt="Art of Where"
              />
            </HeaderLink>
          </Stack>
          <UserNav />
        </Stack>
      </Container>
    </Box>

    <DesktopNav />

    { /*<Promobar>
      <Stack direction={{ xs: 'column', sm: 'row'}} spacing={{xs: 1, sm: 2}} alignItems="center" justifyContent="center">
        <span>
          <Trans
            t={t}
            i18nKey={tKey('All orders other than bottles and placement print clothing continue to ship <strong>tariff-free</strong>')}
            components={{
              strong: <strong />
            }}
          />
        </span>
        <small><a
          href="https://blog.artofwhere.com/tariff-megathread-artofwhere-updated-monthly/"
          target="_blank"
          style={{
            textDecoration: 'underline',
            color: '#fff'
          }}>{t('Learn more')}</a></small>
      </Stack>
    </Promobar> */ }

    <Toast />

    <CookieConsent />
  </HeaderNavigationProvider>
}
